import { getProjectPath, getProjectsBasePath } from '@verantos-dev/core-constants';
import type { PageHeaderBreadcrumb } from '@verantos-dev/shared-components';

import { useAnalysisRouteParams } from './useAnalysisRouteParams';

/**
 * Breadcrumbs for the analysis detail page: `Project home / <analysis>`.
 */
export const useAnalysisBreadcrumbs = (analysisName: string): PageHeaderBreadcrumb[] => {
  const { projectId } = useAnalysisRouteParams();

  return [
    {
      label: 'Project home',
      href: projectId ? getProjectPath(projectId) : getProjectsBasePath(),
    },
    { label: analysisName },
  ];
};
